import axios from 'axios'
import { API_BASE_URL } from '../constants/system'
import type { MoveUserTableRequest, MoveUserTableResponse, RemoveTablesRequest, RemoveTablesResponse, RenameUserFolderRequest, RenameUserFolderResponse } from '../types/gotypes'

export const tocApi = {
  createFolder: (customer: string, job: string, parent: string, name: string) =>
    axios.post(`${API_BASE_URL}/job/${customer}/${job}/toc/folders`, { parent, name }),

  deleteFolder: (customer: string, job: string, path: string) =>
    axios.delete(`${API_BASE_URL}/job/${customer}/${job}/toc/folders`, { params: { path } }),

  renameItem: (customer: string, job: string, path: string, newName: string, isFolder: boolean) =>
    axios.put(`${API_BASE_URL}/job/${customer}/${job}/toc/rename`, { path, newName, isFolder }),

  moveTable: (customer: string, job: string, path: string, destFolder: string) =>
    axios.put(`${API_BASE_URL}/job/${customer}/${job}/toc/move`, { path, destFolder }),

  // #1795: delete tables and whole folders (every depth) in one request.
  // dryRun reports what would go and which outputs use it, and deletes nothing.
  removeTables: async (customer: string, job: string, body: RemoveTablesRequest): Promise<RemoveTablesResponse> =>
    (await axios.post<RemoveTablesResponse>(`${API_BASE_URL}/tables/${customer}/${job}/remove`, body)).data,

  // #1795: rename a My Tables folder and move its tables with it.
  renameUserFolder: async (customer: string, job: string, body: RenameUserFolderRequest): Promise<RenameUserFolderResponse> =>
    (await axios.post<RenameUserFolderResponse>(`${API_BASE_URL}/tables/${customer}/${job}/user-folder/rename`, body)).data,

  // #1795 follow-up: move (and optionally rename) one My Tables table. The
  // server moves the blob, so the tree shows it in its new folder.
  moveUserTable: async (customer: string, job: string, body: MoveUserTableRequest): Promise<MoveUserTableResponse> =>
    (await axios.post<MoveUserTableResponse>(`${API_BASE_URL}/tables/${customer}/${job}/user-table/move`, body)).data,
}
